var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[(!_vm.canCreateBasicOrders)?[_c('full-create',{attrs:{"parent-order":_vm.parentOrder}})]:_c('div',{staticClass:"orders-create"},[_c('div',{staticClass:"columns",staticStyle:{"background-color":"#777","margin":"0"}},[_c('div',{staticClass:"column is-6"},[_c('basic-create',{attrs:{"parent-order":_vm.parentOrder}})],1)])])],2)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-ca9d7930","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/pages/Orders/create/index.vue
// module id = null
// module chunks = 